import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Naruto%20manga%20pages%20spread%20with%20action%20scenes%2C%20Japanese%20comic%20style%2C%20warm%20amber%20tones%2C%20dynamic%20composition%2C%20ink%20lines%20and%20screentones&width=600&height=400&seq=cat-manhua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Open%20book%20with%20Japanese%20text%20and%20Naruto%20illustrations%2C%20warm%20reading%20nook%20with%20soft%20lamp%20light%2C%20cozy%20atmosphere%2C%20literary%20vibe&width=600&height=400&seq=cat-xiaoshuo&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Naruto%20character%20art%20illustrations%20gallery%20wall%20display%2C%20beautiful%20framed%20anime%20art%2C%20warm%20gallery%20lighting%2C%20elegant%20exhibition%20space&width=600&height=400&seq=cat-huaji&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Two%20Naruto%20characters%20in%20romantic%20embrace%20silhouette%20against%20sunset%2C%20warm%20pink%20and%20orange%20sky%2C%20cherry%20blossom%20petals%2C%20emotional%20anime%20art&width=600&height=400&seq=cat-cp&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Anime%20convention%20with%20Naruto%20cosplayers%20and%20booths%2C%20vibrant%20event%20hall%2C%20warm%20lighting%2C%20crowded%20but%20exciting%20atmosphere%2C%20banners%20and%20merchandise&width=600&height=400&seq=cat-huodong&orientation=landscape',
];

export default function CategoryNavSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            分类浏览
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">
            按类别探索你感兴趣的火影同人内容，五大专区等你发现
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative h-64 rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={categoryImages[index]}
                alt={cat.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-center">
                <div className="flex items-center justify-center gap-1 mb-2">
                  <i className={`${cat.icon} text-primary-400 text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-background-50 mb-1">{cat.name}</h3>
                <span className="text-xs text-background-50/70">{cat.count} 篇作品</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}